import React, { useRef, useState } from "react";
import { getBase64 } from "../../helper";

const Jobdescription = ({ data, onSave }) => {
  const [error, setError] = useState(false);
  const el = useRef();

  const handleChange = async (e) => {
    const file = e.target.files[0];
    if (file.size > 5e6) {
      setError(true);
      return false;
    }
    const baseFile = await getBase64(file);
    let fileData = file;
    // console.log(file.name);
    fileData.baseFile = baseFile;
    onSave("jobdescription", fileData);
    setError(false);
  };

  return (
    <>
      <section className="jobDescSection">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="heading">
                <h4>6. Upload Your Job Description</h4>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-4 col-md-6">
              <form>
                <div className="form-group">
                  <label htmlFor="userfile">Upload your document</label>
                  <div className="file-upload">
                    <div className="file-select">
                      <div className="file-select-button">Choose File</div>
                      <div className="file-select-name" title={data.name}>
                        {data.name ?? "No file chosen..."}
                      </div>
                      <input
                        type="file"
                        name="userfile"
                        ref={el}
                        onChange={handleChange}
                        accept=".doc, .docx, application/pdf, .png, .jpg, .jpeg"
                      />
                    </div>
                  </div>
                  {error ? (
                    <span className="text-danger">
                      Please upload a file smaller than 5 MB
                    </span>
                  ) : null}
                </div>
                <div>
                  <p>OR</p>
                </div>
                <div className="form-group">
                  <textarea
                    className="form-control"
                    name="requirement"
                    rows={3}
                    placeholder="Enter your requirements"
                    value={data.requirements}
                    onChange={(e) =>
                      onSave("jobdescription", {
                        ...data,
                        requirements: e.target.value,
                      })
                    }
                  ></textarea>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Jobdescription;
